import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import { computed, defineComponent } from "vue";
import HomeListTitle from "./homeListTitle.vue";
import MvList from "@/components/mv-list/mvList.vue";
export default defineComponent({
  name: "cmdMv",
  props: {
    cmdMvList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    /* 获取每个歌的歌手 */
    var cmdMvSonger = computed(function () {
      return props.cmdMvList.map(function (item) {
        return item.artists.map(function (item) {
          return item.name;
        }).join("/");
      });
    });
    return {
      cmdMvSonger: cmdMvSonger
    };
  },
  components: {
    HomeListTitle: HomeListTitle,
    MvList: MvList
  }
});